import { useState, useEffect } from 'react'

type Platform = 'ios' | 'android' | 'web'

interface CapacitorInfo {
  isNative: boolean
  platform: Platform
}

// Détection Capacitor sans import direct pour éviter les erreurs en mode web
function detectCapacitor(): CapacitorInfo {
  try {
    const win = window as Window & {
      Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string }
    }
    const cap = win.Capacitor
    if (!cap) return { isNative: false, platform: 'web' }
    const isNative = cap.isNativePlatform?.() ?? false
    const rawPlatform = cap.getPlatform?.() ?? 'web'
    const platform: Platform =
      rawPlatform === 'ios' ? 'ios' : rawPlatform === 'android' ? 'android' : 'web'
    return { isNative, platform }
  } catch {
    return { isNative: false, platform: 'web' }
  }
}

export function useCapacitor(): CapacitorInfo {
  const [info] = useState<CapacitorInfo>(detectCapacitor)
  return info
}
